<template>
<v-tabs :vertical="!$vuetify.breakpoint.xsOnly" :show-arrows="!$vuetify.breakpoint.xsOnly" background-color="primary" dark>
  <v-tab>{{ $t('lang.en') }}</v-tab>
  <v-tab>{{ $t('lang.zh-TW') }}</v-tab>
  <v-tab-item>
    <v-container>
      <EN></EN>
    </v-container>
  </v-tab-item>
  <v-tab-item>
    <v-container>
      <ZHTW></ZHTW>
    </v-container>
  </v-tab-item>
</v-tabs>
</template>

<script>
import EN from '@/components/legal/PrivacyPolicyEN'
import ZHTW from '@/components/legal/PrivacyPolicyZHTW'

export default {
  name: 'PrivacyPolicy',
  components: {
    EN,
    ZHTW
  }
}
</script>
